<template>
  <fragment>
    <v-container fluid pa-0>
      <v-layout justify-center column fill-height>
        <template v-for="(content, index) in inputArray">
          <v-layout :key="index" row fill-height>
            <v-flex shrink>
              <v-layout column fill-height>
                <v-flex grow :style="(index === inputArray.length - 1) ? 'min-height: 40px;' : ''">
                </v-flex>
                <v-flex shrink>
                  <CButton
                    v-if="(index === inputArray.length - 1) && !(limit > 0 && inputArray.length === limit)"
                    small
                    fab
                    color="accent"
                    @click="() => onAddContent(inputArray)"
                  >
                    <v-icon>add</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex  shrink :style="(index === inputArray.length - 1) ? 'margin-left: -30px' : 'margin-left:10px'">
              <SelectField
                v-model="input[index]"
                :label="name"
                name="genre_id"
                :options="options"
                text-key="label"
                value-key="value"
                :multiple="false"
                :width="width"
              />
            </v-flex>

            <v-flex shrink>
              <v-layout column fill-height>
                <v-flex grow>
                  <CButton
                          color="red"
                          small
                          fab
                          dark
                          @click="() => onDeleteContent(inputArray, index)"
                  >
                    <v-icon>clear</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import SelectField from "./select";

export default {
  components: {
    SelectField
  },
  props: {
    input: {
      type: Array,
      default: () => []
    },
    resourceName: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "300px"
    },
    limit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ""
    },
    optionType: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    inputArray() {
      if(this.input.length < 1) {
        return [0];
      }
      return this.input;
    },
    options() {
      return this.$store.getters[`${this.optionType}/options/options`];
    }
  },
  methods: {
    onAddContent(input) {
      let initEntity = "";

      if(!(this.limit > 0 && input.length + 1 > this.limit) && input[input.length - 1] !== initEntity)
      {
        input.push(initEntity);
      }
    },
    onDeleteContent(input, index) {
      input.splice(index, 1);
      if(input.length === 0) {
        this.onAddContent(input);
      }
    }
  },
  created(){
    this.$store.dispatch(`${this.optionType}/options/index`);
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
